var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportInsta52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 15.9C34.2732 15.9 34.9 15.2732 34.9 14.5C34.9 13.7268 34.2732 13.1 33.5 13.1C32.7268 13.1 32.1 13.7268 32.1 14.5C32.1 15.2732 32.7268 15.9 33.5 15.9Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6 7.40002H16.4C11.4 7.40002 7.4 11.4 7.4 16.4V31.6C7.4 36.6 11.4 40.6 16.4 40.6H31.6C36.6 40.6 40.6 36.6 40.6 31.6V16.4C40.6 11.4 36.6 7.40002 31.6 7.40002ZM37.8 31.6C37.8 35 35 37.8 31.6 37.8H16.4C13 37.8 10.2 35 10.2 31.6V16.4C10.2 13 13 10.2 16.4 10.2H31.6C35 10.2 37.8 13 37.8 16.4V31.6Z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15C19 15 15 19 15 24C15 29 19 33 24 33C29 33 33 29 33 24C33 19 29 15 24 15ZM24 30.2C20.6 30.2 17.8 27.4 17.8 24C17.8 20.6 20.6 17.8 24 17.8C27.4 17.8 30.2 20.6 30.2 24C30.2 27.4 27.4 30.2 24 30.2Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportInsta52);
export default __webpack_public_path__ + "static/media/icons-2_export-INSTA-52.95daf771c45d39a66a4fa213988a1953.svg";
export { ForwardRef as ReactComponent };